// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px;
}

.modal-content-large {
  background: white;
  border-radius: 8px;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-header h5 {
  margin: 0;
  font-size: 1.25rem;
}

.modal-body {
  padding: 20px;
}

.badge {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.badge.badge-success {
  background-color: #28a745;
  color: white;
}
.badge.badge-danger {
  background-color: #dc3545;
  color: white;
}
.badge.badge-warning {
  background-color: #ffc107;
  color: #212529;
}
.badge.badge-info {
  background-color: #17a2b8;
  color: white;
}
.badge.badge-primary {
  background-color: #007bff;
  color: white;
}
.badge.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 20px;
}
.card .card-body {
  padding: 20px;
}

.alert {
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.alert mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.alert.alert-success {
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
}
.alert.alert-danger {
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  color: #721c24;
}
.alert.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  color: #856404;
}
.alert.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}

.progress {
  height: 20px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}
.progress .progress-bar {
  height: 100%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  transition: width 0.6s ease;
}
.progress .progress-bar.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}
.progress .progress-bar.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.token-usage-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px 20px;
}
.token-usage-card h6 {
  margin: 0 0 5px 0;
  color: #495057;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.token-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.token-label {
  font-size: 11px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.token-value {
  font-size: 20px;
  font-weight: 700;
  color: #212529;
}
.token-value.token-total {
  color: #007bff;
}

.token-summary {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  background-color: #e8f4fd;
  border-radius: 4px;
  font-size: 12px;
  color: #0c5460;
  font-weight: 500;
}

.log-console-wrapper {
  margin-top: 24px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.log-console-header {
  background: #f8f9fa;
  color: #495057;
  padding: 8px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid #dee2e6;
  -webkit-user-select: none;
          user-select: none;
}

.log-clear-btn {
  background: transparent;
  border: 1px solid #ced4da;
  color: #6c757d;
  font-size: 12px;
  padding: 2px 8px;
  line-height: 1.4;
}
.log-clear-btn:hover {
  border-color: #adb5bd;
  color: #343a40;
  background: rgba(0, 0, 0, 0.04);
}

.log-console-body {
  background: #ffffff;
  color: #212529;
  font-family: "Cascadia Code", "Consolas", "Courier New", monospace;
  font-size: 12px;
  line-height: 1.55;
  padding: 10px 14px;
  height: 400px;
  overflow-y: auto;
}
.log-console-body::-webkit-scrollbar {
  width: 7px;
}
.log-console-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.log-console-body::-webkit-scrollbar-thumb {
  background: #ced4da;
  border-radius: 4px;
}
.log-console-body::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

.log-line {
  padding: 1px 0;
  word-break: break-word;
  white-space: pre-wrap;
  color: #212529;
}
.log-line.log-warn {
  color: #856404;
}
.log-line.log-error {
  color: #721c24;
}
.log-line.log-empty {
  color: #adb5bd;
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/modernization-readiness/modernization-readiness.component.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AAAF;;AAGA;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AAEE;EACE,SAAA;EACA,kBAAA;AAAJ;;AAIA;EACE,aAAA;AADF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAFF;AAIE;EACE,yBAAA;EACA,YAAA;AAFJ;AAKE;EACE,yBAAA;EACA,YAAA;AAHJ;AAME;EACE,yBAAA;EACA,cAAA;AAJJ;AAOE;EACE,yBAAA;EACA,YAAA;AALJ;AAQE;EACE,yBAAA;EACA,YAAA;AANJ;AASE;EACE,yBAAA;EACA,YAAA;AAPJ;;AAYA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;AATF;AAWE;EACE,aAAA;AATJ;;AAcA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAXF;AAaE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAXJ;AAcE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAZJ;AAeE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAbJ;AAgBE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAdJ;AAiBE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAfJ;;AAoBA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,YAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,2BAAA;AAjBJ;AAmBI;EACE,qMAAA;EAUA,0BAAA;AA1BN;AA6BI;EACE,kDAAA;AA3BN;;AAgCA;EACE;IACE,2BAAA;EA7BF;EA+BA;IACE,wBAAA;EA7BF;AACF;AAiCA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AA/BF;AAiCE;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAhCF;;AAmCA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AAhCF;;AAmCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhCF;AAkCE;EACE,cAAA;AAhCJ;;AAoCA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAjCF;;AAsCA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yCAAA;AAnCF;;AAsCA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;UAAA,iBAAA;AAnCF;;AAsCA;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAnCF;AAqCE;EACE,qBAAA;EACA,cAAA;EACA,+BAAA;AAnCJ;;AAuCA;EACE,mBAAA;EACA,cAAA;EACA,kEAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AApCF;AAsCE;EACE,UAAA;AApCJ;AAsCE;EACE,mBAAA;AApCJ;AAsCE;EACE,mBAAA;EACA,kBAAA;AApCJ;AAqCI;EAAU,mBAAA;AAlCd;;AAsCA;EACE,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AAnCF;AAqCE;EAAc,cAAA;AAlChB;AAmCE;EAAc,cAAA;AAhChB;AAiCE;EAAc,cAAA;EAAgB,kBAAA;AA7BhC","sourcesContent":["// Modal overlay styles\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.modal-content-large {\n  background: white;\n  border-radius: 8px;\n  max-width: 1200px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  padding: 20px;\n  border-bottom: 1px solid #dee2e6;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  h5 {\n    margin: 0;\n    font-size: 1.25rem;\n  }\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n// Badge styles (matching other components)\n.badge {\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  \n  &.badge-success {\n    background-color: #28a745;\n    color: white;\n  }\n  \n  &.badge-danger {\n    background-color: #dc3545;\n    color: white;\n  }\n  \n  &.badge-warning {\n    background-color: #ffc107;\n    color: #212529;\n  }\n  \n  &.badge-info {\n    background-color: #17a2b8;\n    color: white;\n  }\n  \n  &.badge-primary {\n    background-color: #007bff;\n    color: white;\n  }\n  \n  &.badge-secondary {\n    background-color: #6c757d;\n    color: white;\n  }\n}\n\n// Card styles (matching other components)\n.card {\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  \n  .card-body {\n    padding: 20px;\n  }\n}\n\n// Alert styles (matching other components)\n.alert {\n  padding: 12px 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  \n  mat-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n  }\n  \n  &.alert-success {\n    background-color: #d4edda;\n    border: 1px solid #c3e6cb;\n    color: #155724;\n  }\n  \n  &.alert-danger {\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    color: #721c24;\n  }\n  \n  &.alert-warning {\n    background-color: #fff3cd;\n    border: 1px solid #ffeeba;\n    color: #856404;\n  }\n  \n  &.alert-info {\n    background-color: #d1ecf1;\n    border: 1px solid #bee5eb;\n    color: #0c5460;\n  }\n}\n\n// Progress bar styles\n.progress {\n  height: 20px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n  \n  .progress-bar {\n    height: 100%;\n    background-color: #007bff;\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.85rem;\n    transition: width 0.6s ease;\n    \n    &.progress-bar-striped {\n      background-image: linear-gradient(\n        45deg,\n        rgba(255, 255, 255, 0.15) 25%,\n        transparent 25%,\n        transparent 50%,\n        rgba(255, 255, 255, 0.15) 50%,\n        rgba(255, 255, 255, 0.15) 75%,\n        transparent 75%,\n        transparent\n      );\n      background-size: 1rem 1rem;\n    }\n    \n    &.progress-bar-animated {\n      animation: progress-bar-stripes 1s linear infinite;\n    }\n  }\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 1rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n\n// Token usage card\n.token-usage-card {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 15px 20px;\n\n  h6 {\n    margin: 0 0 5px 0;\n    color: #495057;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n}\n\n.token-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 10px;\n  background: white;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.token-label {\n  font-size: 11px;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.token-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #212529;\n\n  &.token-total {\n    color: #007bff;\n  }\n}\n\n.token-summary {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 8px;\n  background-color: #e8f4fd;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #0c5460;\n  font-weight: 500;\n}\n\n// ==================== Live Log Console ====================\n\n.log-console-wrapper {\n  margin-top: 24px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid #dee2e6;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.log-console-header {\n  background: #f8f9fa;\n  color: #495057;\n  padding: 8px 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 600;\n  border-bottom: 1px solid #dee2e6;\n  user-select: none;\n}\n\n.log-clear-btn {\n  background: transparent;\n  border: 1px solid #ced4da;\n  color: #6c757d;\n  font-size: 12px;\n  padding: 2px 8px;\n  line-height: 1.4;\n\n  &:hover {\n    border-color: #adb5bd;\n    color: #343a40;\n    background: rgba(0, 0, 0, 0.04);\n  }\n}\n\n.log-console-body {\n  background: #ffffff;\n  color: #212529;\n  font-family: 'Cascadia Code', 'Consolas', 'Courier New', monospace;\n  font-size: 12px;\n  line-height: 1.55;\n  padding: 10px 14px;\n  height: 400px;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 7px;\n  }\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: #ced4da;\n    border-radius: 4px;\n    &:hover { background: #adb5bd; }\n  }\n}\n\n.log-line {\n  padding: 1px 0;\n  word-break: break-word;\n  white-space: pre-wrap;\n  color: #212529;\n\n  &.log-warn  { color: #856404; }\n  &.log-error { color: #721c24; }\n  &.log-empty { color: #adb5bd; font-style: italic; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
